import type {
  Component,
  ILayoutComponent,
} from '@/ts/types/dto/interventions-dto';
import {AppError} from '@/ts/utils/errors';
import {ErrorCodesDto} from '@/ts/types/dto/error-codes-dto';

/** Extracts the unique identifier from a session component, throwing if none is found */
export function getId(component: Component): string {
  const res = component.questionnaire?.id
    ?? component.journal?.userComponentId
    ?? component.table?.id
    ?? component.conceptualizationWorksheet?.userComponentId
    ?? component.problemSolvingWorksheet?.userComponentId
    ?? component.content?.id
    ?? component.questionnaireReview?.id
    ?? component.componentLayout?.contentId
    ?? component.imageGrid?.id;
  if (!res) {
    throw new AppError('Component has no id', ErrorCodesDto.UNKNOWN);
  }
  return res;
}

/** Extracts the unique identifier from a layout component, throwing if none is found */
export function getLayoutId(component: ILayoutComponent): string {
  const res = component.questionnaire?.id
    ?? component.journal?.userComponentId
    ?? component.table?.id
    ?? component.content?.id
    ?? component.questionnaireReview?.id
    ?? component.goal?.id;
  if (!res) {
    throw new AppError('Component has no id', ErrorCodesDto.UNKNOWN);
  }
  return res;
}
